import { z } from "zod";

import {ContactSchema} from "@/models/Contact";
import {ClientSchema} from "@/models/Client";
import {TradeSchema} from "@/models/Trade";

export const CompanySchema = z.object({
    id: z.coerce.number(),
    name: z.string().optional(),
    address: z.string().optional().nullable(),
    address2: z.string().optional().nullable(),
    city: z.string().optional().nullable(),
    state: z.string().optional().nullable(),
    zip: z.string().optional().nullable(),
    country: z.string().optional().nullable(),
    prequal_url: z.string().optional().nullable(),
    latest_terms_accepted: z.boolean().optional().nullable(),

    client: ClientSchema.optional().default(ClientSchema.parse({})),
    primary_contact: ContactSchema.optional().default(ContactSchema.parse({})),
    trades: z.array(TradeSchema).optional().default([]),
});


export type Company = z.infer<typeof CompanySchema>;